// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3W_Pt","rightAdornment":"Header_rightAdornment__1fNPk"};